import React from "react";
import { MoreVert } from "@mui/icons-material";
import { 
  Card,
  CardMedia,
  CardHeader,
  CardContent,
  CardActions,
  Menu,
  MenuItem,
  IconButton,
  Typography
} from "@mui/material";

function Post(props) {

  const image = props.image;
  
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (

      <Card sx={{ margin: 5 }}>

        <CardHeader
          action={
            <IconButton 
              aria-label="settings"
              id="basic-button"
              aria-controls={open ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
            >
              <MoreVert />
            </IconButton>
          }
          title={props.title}
          subheader={props.date}
        />

        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          <MenuItem onClick={handleClose}>Download</MenuItem>
          <MenuItem onClick={handleClose}>Edit</MenuItem>
          <MenuItem onClick={handleClose}>Delete</MenuItem>
        </Menu>

        {image !== '' ? (
          <CardMedia
            component="img"
            height="20%"
            image={image}
            alt="image"
          />
        ) : (
          <>
          </>
        )}
        
        <CardContent>
          <Typography variant="body2" color="text.secondary">
            {props.content}
          </Typography>
        </CardContent>
      </Card>
    
  );
}

export default Post;